// 检查是否是手机，操作系统
var ua = navigator.userAgent,
  isWindowsPhone = /(?:Windows Phone)/.test(ua),
  isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
  isAndroid = /(?:Android)/.test(ua),
  isFireFox = /(?:Firefox)/.test(ua),
  isChrome = /(?:Chrome|CriOS)/.test(ua),
  isXiaoMi = /(?:XiaoMi)/i.test(ua),
  isOnePlus = /(?:OnePlus|Vivo|One Plus)/i.test(ua),
  isWeixin = ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] == "micromessenger",
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
(isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))),
  (isIPhone = /(?:iPhone)/.test(ua) && !isTablet),
  // isPc = !isIPhone && !isAndroid && !isSymbian

  // var isSafari = ua.indexOf("Safari") > -1;

  // // Discard Safari since it also matches Chrome
  // if ((isChrome) && (isSafari)) isSafari = false;

  // window.isTablet = isTablet
  (window.isIPhone = isIPhone);
window.isAndroid = isAndroid;
// window.isPc = isPc
// window.isPhone = !isPc
window.isWeixin = isWeixin;
window.isXiaoMi = isXiaoMi;
window.isOnePlus = isOnePlus;
window.isSafari = isSafari;

if (window.isAndroid) document.body.classList.add(`${PREFIXER}android`);
if (window.isIPhone) document.body.classList.add(`${PREFIXER}iphone`);
if (window.isWeixin) document.body.classList.add(`${PREFIXER}wexin`);

let div = document.createElement("div");
div.style.position = "fixed";
div.style.top = "0";
div.style.left = "0";
div.style.width = "100vw";
div.style.height = "100vh";
div.style.zIndex = "-111";
div.style.pointerEvents = "none";
document.body.appendChild(div);

// 创建一个 ResizeObserver 来监听 div 的尺寸变化
let observer = new ResizeObserver((entries) => {
  for (let entry of entries) {
    // console.log('Size changed:', entry.contentRect.width, entry.contentRect.height);
    handleContentSize(entry.contentRect.width);
  }
});

function handleContentSize(width) {
  if (width < 768) {
    window.isPhone = true;
    window.isTablet = false;
    window.isPc = false;
  } else if (width < 1024) {
    window.isPhone = false;
    window.isTablet = true;
    window.isPc = false;
  } else {
    window.isPhone = false;
    window.isTablet = false;
    window.isPc = true;
  }

  document.body.classList.remove(`${PREFIXER}mobile`, `${PREFIXER}tablet`, `${PREFIXER}pc`);
  if (window.isPhone) document.body.classList.add(`${PREFIXER}mobile`);
  if (window.isTablet) document.body.classList.add(`${PREFIXER}tablet`);
  if (window.isPc) document.body.classList.add(`${PREFIXER}pc`);
}

observer.observe(div);
//强制触发检查一次
handleContentSize(window.innerWidth);
